import React from "react";

import { StatusBadge } from "@/coquille-bridge";

import { useKarateUi } from "@/hooks/useKarateUi.js";



const TONE_MAP = {

  public: "green",

  membres: "blue",

  admin: "red",

  a_valider: "yellow",

};



/** @param {{ visibilite: string }} props */

export function DocumentVisibilityBadge({ visibilite }) {

  const { visibilityLabel } = useKarateUi();

  return (

    <StatusBadge

      label={visibilityLabel(visibilite)}

      tone={TONE_MAP[visibilite] ?? "neutral"}

      testId={`doc-vis-${visibilite}`}

    />

  );

}



/** @param {{ statut: string }} props */

export function EntityStatusBadge({ statut }) {

  const { ui } = useKarateUi();

  const tone =

    statut === "actif" ? "green" : statut === "inactif" ? "neutral" : "yellow";

  const label = ui.status[statut] ?? statut;

  return <StatusBadge label={label} tone={tone} testId={`status-${statut}`} />;

}


